import React from 'react';
import Icon from '../../../components/AppIcon';

const RegistrationBenefits = () => {
  const benefits = [
    {
      icon: 'FileText',
      title: 'Professional Reports',
      description: 'Generate polished PDF comparison reports that impress sellers and streamline decision-making'
    },
    {
      icon: 'Sparkles',
      title: 'AI-Powered Insights',
      description: 'Leverage intelligent summaries to highlight key differences and present offers with clarity'
    },
    {
      icon: 'Mail',
      title: 'Automated Delivery',
      description: 'Send reports directly to sellers with one click, saving time and ensuring prompt communication'
    },
    {
      icon: 'BarChart3',
      title: 'Unlimited Properties',
      description: 'Manage multiple listings simultaneously with no restrictions on paid plans'
    },
    {
      icon: 'Lock',
      title: 'Secure Data Storage',
      description: 'Your client information and property data are protected with enterprise-grade security'
    },
    {
      icon: 'Clock',
      title: 'Save Hours Weekly',
      description: 'Eliminate manual comparison work and focus on what matters most - closing deals'
    }
  ];

  return (
    <div className="bg-card rounded-xl shadow-elevation-md p-6 md:p-8 lg:p-10">
      <div className="text-center mb-8">
        <h2 className="text-2xl md:text-3xl font-bold text-foreground mb-3">
          Why Real Estate Agents Choose OfferSense
        </h2>
        <p className="text-muted-foreground">
          Join thousands of agents who have transformed their offer management workflow
        </p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {benefits?.map((benefit, index) => (
          <BenefitCard key={index} {...benefit} />
        ))}
      </div>
      <div className="mt-8 pt-8 border-t border-border">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-3">
            <Icon name="Award" size={24} className="text-accent" />
            <div className="text-left">
              <p className="text-sm font-semibold text-foreground">Free Trial Available</p>
              <p className="text-xs text-muted-foreground">Start with 1 property and 2 offers at no cost</p>
            </div>
          </div>
          <div className="flex items-center gap-2 text-sm text-muted-foreground">
            <Icon name="CheckCircle2" size={16} className="text-success" />
            <span>No credit card required</span>
          </div>
        </div>
      </div>
    </div>
  );
};

const BenefitCard = ({ icon, title, description }) => (
  <div className="flex gap-4 p-4 rounded-lg bg-muted hover:bg-muted/80 transition-colors">
    <div className="flex-shrink-0">
      <div className="w-12 h-12 rounded-lg bg-primary/10 flex items-center justify-center">
        <Icon name={icon} size={24} className="text-primary" />
      </div>
    </div>
    <div className="flex-1 min-w-0">
      <h3 className="text-base font-semibold text-foreground mb-1">{title}</h3>
      <p className="text-sm text-muted-foreground leading-relaxed">{description}</p>
    </div>
  </div>
);

export default RegistrationBenefits;